import { render, staticRenderFns } from "./NewBookings.vue?vue&type=template&id=138b076c&scoped=true&"
import script from "./NewBookings.vue?vue&type=script&lang=js&"
export * from "./NewBookings.vue?vue&type=script&lang=js&"
import style0 from "./NewBookings.vue?vue&type=style&index=0&id=138b076c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b076c",
  null
  
)

export default component.exports